import axios from 'axios';

import { ACADEMIC_VIEW_TYPE, accountTypes, CENTRAL_TIMETABLER_VIEW_TYPE, FACILITIES_VIEW_TYPE, localStorageKey, viewTypeStorageKey } from '../constants';
import { getApiUrl } from '../helpers/api-url';
import { IsLocalHost } from '../utils/enviroment';
import { authenticationService } from './authenticationService.service';
import moment from 'moment';
import { toast } from 'react-toastify';

export const userService = {
    loadUserData,
    saveUserData,
    saveUserView,
};

async function loadUserData() {
    const httpClient = axios.create();
    httpClient.interceptors.request.use((request) => {
        const controller = new AbortController();
        let authHeader;
        if (IsLocalHost()) {
            authHeader = `Bearer ${process.env.REACT_APP_JwtToken}`;
        } else {
            let currentUser = authenticationService.currentUserValue;
            if (!currentUser) {
                controller.abort();
                toast.error('Attempt authentication in 2 seconds as there is no current user');
                new Promise((res) => setTimeout(res, 2000)).then(() => {
                    authenticationService.authenticate();
                });
                return {
                    ...request,
                    signal: controller.signal,
                };
            } else if (moment.utc(currentUser.tokenExpiration).isBefore(moment.utc())) {
                controller.abort();
                toast.error('Re-authenticating the user in 2 seconds as token has expired');
                new Promise((res) => setTimeout(res, 2000)).then(() => {
                    authenticationService.logout();
                    authenticationService.authenticate();
                });
                return {
                    ...request,
                    signal: controller.signal,
                };
            } else {
                authHeader = `Bearer ${authenticationService.currentUserValue?.token}`;
            }
        }
        request.headers.setAuthorization(authHeader);
        return request;
    });

    const { data } = await httpClient.get(getApiUrl() + `/user`);

    return data;
}

function saveUserData(data) {
    const dataStr = JSON.stringify(data);
    localStorage.setItem(localStorageKey, dataStr);
}

//TODO: Can we move this logic to backend?
function saveUserView(data) {
    let viewType = '';
    if (data.accountType == accountTypes.facilities) {
        viewType = FACILITIES_VIEW_TYPE;
    } else if (data.accountType == accountTypes.centralTimetabler) {
        viewType = CENTRAL_TIMETABLER_VIEW_TYPE;
    } else {
        viewType = ACADEMIC_VIEW_TYPE;
    }

    localStorage.setItem(viewTypeStorageKey, viewType);
}
